import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../config";

export default function Dashboard({ token, onNewBlog, onViewBlog }) {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await axios.get(`${config.API_BASE_URL}/blogs`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBlogs(response.data);
    } catch (error) {
      console.error("Failed to fetch blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
        <span className="ml-3 text-gray-600">Loading your blogs...</span>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Your Blog Collection</h2>
          <p className="text-gray-600 mt-1">Manage and view your AI-generated blogs</p>
        </div>
        <button
          onClick={onNewBlog}
          className="bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition font-medium flex items-center"
        >
          <span className="mr-2">+</span>
          Create New Blog
        </button>
      </div>

      {blogs.length === 0 ? (
        <div className="text-center py-12 bg-white rounded-xl border border-gray-200">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl">📝</span>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No blogs yet</h3>
          <p className="text-gray-600 mb-6">Start creating your first AI-powered blog post</p>
          <button
            onClick={onNewBlog}
            className="bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition font-medium"
          >
            Create Your First Blog
          </button>
        </div>
      ) : (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {blogs.map((blog) => (
            <div key={blog.id} className="bg-white rounded-xl border border-gray-200 hover:shadow-lg transition-shadow">
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <h3 className="font-semibold text-gray-900 flex-1" style={{display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden'}}>
                    {blog.title}
                  </h3>
                  <span className="text-xs bg-indigo-100 text-indigo-700 px-2 py-1 rounded-full ml-2 whitespace-nowrap">
                    {blog.tone}
                  </span>
                </div>
                
                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-sm text-gray-600">
                    <span className="font-medium mr-2">Audience:</span>
                    <span className="bg-gray-100 px-2 py-1 rounded text-xs">{blog.audience}</span>
                  </div>
                  <div className="text-sm text-gray-500">
                    Created {formatDate(blog.created_at)}
                  </div>
                </div>

                <div className="border-t pt-4">
                  <button
                    onClick={() => onViewBlog(blog)}
                    className="w-full bg-gray-50 text-gray-700 py-2 rounded-lg hover:bg-gray-100 transition font-medium"
                  >
                    View Blog
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}